import React, { memo } from "react";
import { LinkGenerator } from "@/utils/LinkGenerator";
import moment from "moment";
import { Link } from "react-router-dom";
import type { tBizClient } from "@/types";
import type { TFunction } from "i18next";
import { MASTER_CLIENTS_NS } from "@/i18n/ns";

type tProps = {
  client: tBizClient;
  t: TFunction;
};
const ClientInfo = ({ client, t }: tProps) => {
  return (
    <>
      <Row
        title={t(`${MASTER_CLIENTS_NS}:client_source`, { defaultValue: null })}
        value={t(`common:client_sources.${client.source || "void"}`)}
      />
      <Row title={t("common:first_name")} value={client.full_name} />
      <Row title={t("common:phone")} value={client.phone} />
      <Row title="Email" value={client.email} />
      <Row title={t("common:address")} value={client.location_hr} />
      {client.user && (
        <Row
          isLink
          isExternalLink={false}
          title={t("common:profile")}
          value={LinkGenerator.clientProfile(client.user)}
        />
      )}
      {client.insta_id && (
        <Row
          title="Instagram"
          isLink
          value={LinkGenerator.insta(client.insta_id)}
        />
      )}
      {client.vk_id && (
        <Row isLink title="Vkontakte" value={LinkGenerator.vk(client.vk_id)} />
      )}
      {client.tg_id && (
        <Row isLink title="Telegram" value={LinkGenerator.tg(client.tg_id)} />
      )}
      {client.birthdate && (
        <Row
          title={t("common:birthdate")}
          value={`${moment(client.birthdate).format("L")} (${moment().diff(
            client.birthdate,
            "years",
          )})`}
        />
      )}
      <Row title={t("common:comment")} value={client.comment} />
      {client.custom_fields &&
        client.custom_fields.map((field) => (
          <Row title={field.key} value={field.value} />
        ))}
    </>
  );
};

const Row = ({
  title,
  value,
  isLink,
  isExternalLink = true,
}: {
  title: string;
  value?: string;
  isLink?: boolean;
  isExternalLink?: boolean;
}) => {
  if (!value) return null;
  return (
    <div
      css={`
        margin-bottom: 10px;
        a {
          color: inherit;
          text-decoration: underline;
        }
      `}
    >
      <div
        css={`
          font-weight: 700;
          margin-bottom: 2px;
        `}
      >
        {title}
      </div>
      {isLink ? (
        <>
          {isExternalLink ? (
            <a target="_blank" rel="noopener noreferrer" href={value}>
              {value}
            </a>
          ) : (
            <Link to={value}>{value}</Link>
          )}
        </>
      ) : (
        <div>{value}</div>
      )}
    </div>
  );
};

export default memo(ClientInfo);
